export interface TermsPageData {}

export interface TermsPageProps extends TermsPageData {}
